import { queryOptions } from '@tanstack/react-query'

import { fetchShipmentOrders } from '../api'
import { shipmentOrdersQueryKeys } from '../query-keys'

/**
 * 束ね（まとめキー）のメンバー配送依頼を全件取得するクエリ定義。
 * 一覧はページング・絞り込みが効くため同じ束ねのメンバーが同一ページに揃うとは限らない。
 * まとめキーから束ねを扱うときは、一覧の検索条件と切り離して bundleId だけで引き直す。
 *
 * まとめキーのチェックからの一括選択 (queryClient.fetchQuery) が使う。
 */
export const bundleOrdersQueryOptions = ({
  tenantKey,
  bundleId
}: {
  tenantKey: string
  bundleId: number
}) =>
  queryOptions({
    queryKey: shipmentOrdersQueryKeys.bundle(tenantKey, bundleId),
    queryFn: ({ signal }) =>
      fetchShipmentOrders(
        {
          tenantKey,
          query: {
            bundleId,
            // 束ねは配車済メンバーを含みうるので、一覧同様に配車済も取得する
            includeDispatched: true,
            page: -1
          }
        },
        signal
      ),
    staleTime: 0
  })
